"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleStorageBased__factory = void 0;
var ethers_1 = require("ethers");
var SampleStorageBased__factory = /** @class */ (function (_super) {
    __extends(SampleStorageBased__factory, _super);
    function SampleStorageBased__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SampleStorageBased__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SampleStorageBased__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SampleStorageBased__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SampleStorageBased__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SampleStorageBased__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return SampleStorageBased__factory;
}(ethers_1.ContractFactory));
exports.SampleStorageBased__factory = SampleStorageBased__factory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "symbol",
                type: "bytes32",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "symbol",
                type: "bytes32",
            },
        ],
        name: "currentValueOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "symbol",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract PriceFeed",
                name: "_priceFeed",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "fromSymbol",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "toSymbol",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "swap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=SampleStorageBased__factory.js.map